import { NavegacionProductos } from '../../components';

const FrijolesRefritosConChorizo = () => {
    return <NavegacionProductos />;
};

export default FrijolesRefritosConChorizo;
